/*
**************************** 
홈페이지 공지사항 내용
*****************************
*/

import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BoardContent from "./BoardContent";
import BoardList from "./BoardList";
import BoardSearch from "./BoardSearch";
import Pagination from "./Pagination";

export default function NoticeDetail(props) {
    const pathData = useParams();

    const [noticeData, setNoticeData] = useState({ data: [], page: 0, totalCount: 0, listType: "list" });
    const req = async function (_page) {
        const reqSql = "/api/notice/" + _page;
        await axios.get(reqSql).then(function (res) {
            if (res.data.t_count > 0) {
                let copyData = [...noticeData.data];
                copyData.data = res.data.t_data;

                let copyNoticeData = { ...noticeData, data: copyData.data, page: _page, totalCount: res.data.t_count, listType: "list" };
                setNoticeData(copyNoticeData);
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }

        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    const reqFind = async function (_page, _find) {
        const reqSql = "/api/notice/find/" + _page + "/" + _find;
        await axios.get(reqSql).then(function (res) {
            if (res.data.t_count > 0) {
                let copyData = [...noticeData.data];
                copyData.data = res.data.t_data;

                let copyNoticeData = { ...noticeData, data: copyData.data, page: _page, totalCount: res.data.t_count, listType: _find };
                setNoticeData(copyNoticeData);
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    useEffect(() => {
        if (pathData.listType === "list") {
            req(pathData.page);
        } else {
            reqFind(pathData.page, pathData.listType);
        }
    }, [pathData.idx]);

    return (
        <div >
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item active small">공지사항</li>
                </ol>
                <BoardContent data={noticeData.data} page={pathData.page} idx={pathData.idx} count={noticeData.totalCount}></BoardContent>

                <BoardList detailData={noticeData}></BoardList>
                <Pagination page={pathData.page} count={noticeData.totalCount} ></Pagination>
                <BoardSearch page={pathData.page} fn={reqFind}></BoardSearch>

            </div>
        </div>
    )
}